import { render, staticRenderFns } from "./InvitacionesComponent.vue?vue&type=template&id=4d2f9665"
import script from "./InvitacionesComponent.vue?vue&type=script&lang=js"
export * from "./InvitacionesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports